import { useEffect, useState } from 'react'
import { find, propEq } from 'ramda'
import { WizardContent } from '@/components/wizard'
import { isNullOrEmpty } from '@/utils'
import { PersonalInfo, FinancialInfo, Review, PadFormContext } from '@/features/Pad'
import useProfile from '@/hooks/use-profile'

const PadWizardForm = ({
  currentStep,
  setCurrentStep,
  handleBack,
  onSuccess,
  isModal,
  padInfo,
  listingInfo,
  padContracts,
  canDelete = false,
  noEdit
}) => {
  const hasPadInfo = !isNullOrEmpty(padInfo)
  const profile = useProfile()
  const first = profile?.first_name
  const last = profile?.last_name
  const [formData, setFormData] = useState({})

  useEffect(() => {
    if (!first || !last) return
    setFormData(data => ({
      ...data,
      first_name: data?.first_name || first,
      last_name: data?.last_name || last
    }))
  }, [first, last])

  const connectedContract = find(propEq('pad_active', true))(padContracts)
  const hasContract = !isNullOrEmpty(connectedContract)

  useEffect(() => {
    if (hasPadInfo) {
      const { financial_info, personal_info } = padInfo
      const initialValues = {
        first_name: personal_info?.first_name || '',
        last_name: personal_info?.last_name || '',
        phone_number: personal_info?.phone_number || '',
        email: personal_info?.email || '',
        company_name: personal_info?.company_name || '',
        street1: personal_info?.street1 || '',
        street2: personal_info?.street2 || '',
        city: personal_info?.city || '',
        zip: personal_info?.zip || '',
        country: personal_info?.country || 'ca',
        state: personal_info?.state || '',
        financial_institution_name: financial_info?.financial_institution_name || '',
        custom_financial_institution: financial_info?.custom_financial_institution || '',
        account_type: financial_info?.account_type || '',
        transit_number: '',
        financial_institution_number: financial_info?.financial_institution_number || '',
        account_number: '',
        bank_street1: financial_info?.street1 || '',
        bank_street2: financial_info?.street2 || '',
        bank_city: financial_info?.city || '',
        bank_zip: financial_info?.zip || '',
        bank_country: 'ca',
        bank_state: financial_info?.state || ''
      }
      setFormData(initialValues)
    }
  }, [padInfo, hasPadInfo])

  return (
    <PadFormContext.Provider value={{ formData, setFormData }}>
      <WizardContent currentStep={currentStep}>
        <PersonalInfo
          index="personal_info"
          setCurrentStep={setCurrentStep}
          handleBack={handleBack}
          isModal={isModal}
        />
        <FinancialInfo
          index="financial_info"
          setCurrentStep={setCurrentStep}
          handleBack={handleBack}
          isModal={isModal}
          count=""
          hasContract={hasContract}
          onSuccess={onSuccess}
        />
        <Review
          index="review"
          handleBack={handleBack}
          onSuccess={onSuccess}
          listingInfo={listingInfo}
          isModal={isModal}
          padContract={connectedContract}
          padInfo={padInfo}
          noEdit={noEdit}
        />
      </WizardContent>
    </PadFormContext.Provider>
  )
}

export default PadWizardForm
